import { render, staticRenderFns } from "./activation-email-page.vue?vue&type=template&id=24e06bf8&scoped=true&lang=pug"
import script from "./activation-email-page.js?vue&type=script&lang=js&external"
export * from "./activation-email-page.js?vue&type=script&lang=js&external"
import style0 from "./activation-email-page.vue?vue&type=style&index=0&id=24e06bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e06bf8",
  null
  
)

export default component.exports